/**
 * Servicio de autenticación
 * Llamadas a la API para register, login, logout, me
 */

import { apiClient } from './api';
import type {
    AuthResponse,
    UserResponse,
    LoginCredentials,
    RegisterData,
} from '../types';

interface AccountDeactivationResponse {
    message: string;
    data: {
        user: UserResponse['data']['user'];
    };
}

export const authService = {
    /**
     * Registrar nuevo usuario
     */
    register: async (data: RegisterData): Promise<AuthResponse> => {
        return apiClient.post<AuthResponse>('/api/auth/register', data, false);
    },

    /**
     * Iniciar sesión
     */
    login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
        return apiClient.post<AuthResponse>('/api/auth/login', credentials, false);
    },

    /**
     * Cerrar sesión
     */
    logout: async (): Promise<{ message: string }> => {
        return apiClient.post<{ message: string }>('/api/auth/logout', {}, true);
    },

    /**
     * Obtener perfil del usuario autenticado
     */
    me: async (): Promise<UserResponse> => {
        return apiClient.get<UserResponse>('/api/auth/me', true);
    },

    deactivateAccount: async (
        scope: 'client' | 'operator' | 'both',
        reason: string,
        details?: string | null,
    ): Promise<AccountDeactivationResponse> => {
        return apiClient.post<AccountDeactivationResponse>('/api/account/deactivation', {
            scope,
            reason,
            details: details ?? null,
        }, true);
    },

    reactivateAccount: async (
        scope: 'client' | 'operator',
    ): Promise<AccountDeactivationResponse> => {
        return apiClient.post<AccountDeactivationResponse>('/api/account/reactivation', {
            scope,
        }, true);
    },
};
